"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var browser_util_1 = require("../../utils/browser.util");
var ATTA_URL = 'https://h.trace.qq.com/kv';
var LogReporter = (function () {
    function LogReporter(options) {
        if (options === void 0) { options = {}; }
        this.columns = ['msg', 'url'];
        this.attaid = '0b400054376';
        this.token = '6871543253';
        this.attaUrl = ATTA_URL;
        this.options = options;
        this.attaid = options.attaid || this.attaid;
        this.token = options.token || this.token;
        this.attaUrl = options.attaUrl || this.attaUrl;
    }
    LogReporter.prototype.logInfo = function (msg) {
        try {
            var itemTmp = {
                msg: msg,
            };
            this.sendLog(itemTmp);
        }
        catch (error) {
        }
    };
    LogReporter.prototype.logErr = function (errOrMsg) {
        var itemTmp = {
            msg: browser_util_1.formatAnyVal(errOrMsg),
        };
        this.sendLog(itemTmp);
    };
    LogReporter.prototype.sendLog = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var atta, queryObj;
            return __generator(this, function (_a) {
                atta = new Image(1, 1);
                queryObj = __assign(__assign({ attaid: this.attaid, token: this.token }, this.itemFormat(item)), { _dc: Math.random() });
                atta.src = "https://h.trace.qq.com/kv?" + browser_util_1.toQueryString(queryObj);
                return [2];
            });
        });
    };
    LogReporter.prototype.itemFormat = function (item) {
        return this.columns.reduce(function (acc, col) {
            var val = item[col];
            if (val === undefined || val === null) {
                acc[col] = '';
            }
            else if (typeof val === 'string' || typeof val === 'number') {
                acc[col] = val;
            }
            else {
                acc[col] = JSON.stringify(val);
            }
            return acc;
        }, {});
    };
    return LogReporter;
}());
exports.default = LogReporter;
//# sourceMappingURL=index.js.map